import React from "react"
import ReactDOM from "react-dom/client"
import "./styles/index.css"
import { store } from "./store"
import App from "./App"
import { Provider } from "react-redux"
import { BrowserRouter as Router } from "react-router-dom"
ReactDOM.createRoot(document.getElementById("root")).render(
    <Router>
        <Provider store={store}>
            <App />
        </Provider>
    </Router>
)
